
import { SALES_API_ENDPOINTS } from "../config/api/apiCallSales";
import { callApi } from "../utils/apiClient";

export const loadCOList = async (payload) => {
    try {        

        return await callApi(SALES_API_ENDPOINTS.despatch.co_list, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};